<app-progress-spinner-demo #loadingModalGeneral id="main-loader-general"> </app-progress-spinner-demo>

<ng-container>
  <app-navbar #navbar id="main-navbar">
    <app-person-type-toggle toggle-person-type-content id="main-toggle-person-type"></app-person-type-toggle>
    <div
      class="text-header-mobile mr-1 d-flex align-items-center"
      extra-secondary-option
      (window:resize)="onResize($event)"
      id="main-header-actions"
      >
      <app-language-selector id="main-language-selector"></app-language-selector>

      @if (isUserAdmin) {
        <span
          title="Incluir cartera"
          i18n-title="@@addWallet"
          class="mr-1 clickable"
          id="main-btn-add-wallet"
          >
          <img
            src="{{ urlAssets }}/icons/nuevacartera.png"
            alt="Nova Carteira"
            (click)="openRegisterCartera()"
            class="sizeMobile"
            style="max-width: 30px"
            id="main-img-add-wallet"
            />
          </span>
        }

        @if (isUserAdmin) {
          <span
            title="Incluir documento"
            i18n-title="@@addDocument"
            class="mr-1 clickable"
            id="main-btn-add-doc"
            >
            <img
              src="{{ urlAssets }}/icons/personasseguimiento.png"
              alt="Incluir documento"
              (click)="openRegisterModal()"
              class="sizeMobile"
              style="max-width: 30px"
              id="main-img-add-doc"
              />
            </span>
          }

          <span title="Carga massiva" class="mr-1 clickable" id="main-btn-upload">
            <img
              src="{{ urlAssets }}/icons/cargamasiva.png"
              alt="Carga massiva"
              (click)="openFileUpload()"
              style="max-width: 30px"
              class="sizeMobile"
              id="main-img-upload"
              />
            </span>

            @if (!getShowComponentNavbar()) {
              <span
                class="showName"
        style="
          background-color: #575756;
          width: 100%;
          height: 100%;
          padding-bottom: 5px;
          padding-top: 7px;
          margin-left: 4px;
        "
                id="main-user-dropdown-wrapper"
                >
                <div
                  class="dropdown"
                  style="background-color: #575756"
                  style="border: none; padding-right: 0"
                  id="main-user-dropdown"
                  >
                  <span
                    class="btn btn-secondary"
                    type="button"
                    id="main-btn-dropdown-user"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style="padding-right: 0"
                    >
                    <span
                      class="mr-2"
              style="
                color: white;
                background-color: #86c7f3;
                width: 30px;
                text-align: center;
                border-radius: 10%;
                margin-left: 2px;
              "
                      id="main-span-user-initials"
                      >
                      {{ firstLetterNamePerson }}
                    </span>
                    <span
                      class="navbar-text hiddenSlider"
                      class="mr-2"
                      style="color: white; font-size: 13px; background-color: transparent"
                      id="main-span-user-name"
                      >{{ namePerson }}</span
                      >
                    </span>
                  </div>
                </span>
              }

              @if (getShowComponentNavbar()) {
                <span
        style="
          background-color: #575756;
          width: 100%;
          height: 100%;
          padding-bottom: 13px;
          padding-top: 7px;
        "
                  id="main-user-mobile-wrapper"
                  >
                  <span
                    class="mr-2"
          style="
            color: white;
            background-color: #86c7f3;
            width: 30px;
            text-align: center;
            border-radius: 70%;
            margin-left: 10px;
          "
                    id="main-span-mobile-initials"
                    >
                    {{ firstLetterNamePerson }}
                  </span>
                  <span
                    class="navbar-text hiddenSlider"
                    class="mr-2"
                    href="#"
                    style="color: white; font-size: 13px"
                    id="main-span-mobile-name"
                    >{{ namePerson }}</span
                    >
                  </span>
                }
              </div>
            </app-navbar>

            <div class="wrapper" [class.d-none]="navbar.searching" id="main-wrapper">
              <app-sidebar
                id="main-sidebar"
                [(classSidebar)]="navbar.classSidebar"
                (selectedOptionNavbar)="selectedOptionNavbar($event)"
                >
              </app-sidebar>

              <div class="container-mobile page-container" id="main-page-container">
                <div class="page-content" id="main-page-content">
                  <div
                    class="col-12"
                    style="margin: 0 !important; padding-top: 1%; padding-right: 40px !important"
                    >
                    <div style="height: 100%">
                      <div class="container container-max-width" id="main-inner-container">
                        <div style="height: 100%">
                          <div style="display: flex; width: 100%; height: 100%; flex-direction: column" id="main-router-outlet-mock">
                            @if (shouldShowPageHeader()) {
                              <div id="main-page-header">
                                <div class="page-header">
                                  <h3 id="main-title-page">{{ textToShow }} - {{ textType }}</h3>
                                  @if (eventSendOption === 'favoritos') {
                                    <div class="tabs-container" id="main-tabs-favorites">
                                      <ul class="nav nav-tabs" id="myTab">
                                        <li class="nav-item" id="main-li-tab-wallets">
                                          <a
                                            class="nav-link"
                                            [ngClass]="{ active: isDocumentsTabSelected === false }"
                                            id="main-tab-wallets"
                                            data-toggle="tab"
                                            href="#human"
                                            role="tab"
                                            aria-controls="human"
                                            aria-selected="true"
                                            (click)="selectWalletsTab()"
                                            i18n="@@wallets"
                                            >
                              Carteras
                            </a>
                                        </li>
                                        <li class="nav-item" id="main-li-tab-documents">
                                          <a
                                            class="nav-link"
                                            [ngClass]="{ active: isDocumentsTabSelected === true }"
                                            id="main-tab-documents"
                                            data-toggle="tab"
                                            href="#company"
                                            role="tab"
                                            aria-controls="company"
                                            aria-selected="false"
                                            (click)="selectDocumentsTab()"
                                            >
                                            <span i18n="@@documents">Documentos</span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  }
                                </div>
                              </div>
                            }

                            @if (eventSendOption === 'dashboardCL') {
                              <app-dashboard-cl id="main-view-dashboard"> </app-dashboard-cl>
                            }

                            @if (eventSendOption === 'favoritos' && isDocumentsTabSelected) {
                              <app-registry-favorite-list
                                id="main-view-reg-favorites"
                                [showAdminActions]="isUserAdmin"
                              ></app-registry-favorite-list>
                            }

                            @if (eventSendOption === 'favoritos' && !isDocumentsTabSelected) {
                              <app-wallet-favorite-list
                                id="main-view-wallet-favorites"
                                (modelSendToRedirect)="selectedOptionNavbarRedirect($event)"
                                >
                              </app-wallet-favorite-list>
                            }

                            @if (eventSendOption === 'carteras') {
                              <app-list-group
                                id="main-view-list-group"
                                [showAdminActions]="isUserAdmin"
                                (modelSendReloadWallets)="reloadWallets()"
                                (finishLoading)="hideDisplayProgressSpinner()"
                                (modelSendToRedirect)="selectedOptionNavbarRedirect($event)"
                                (newWalletShortcutClick)="openRegisterCartera()"
                                (walletTrendClick)="showWalletTrend($event)"
                                >
                              </app-list-group>
                            }

                            @if (eventSendOption === 'walletTrend') {
                              <app-wallet-trend
                                id="main-view-wallet-trend"
                                [wallet]="walletTrendData"
                                (backToList)="backToWalletList()"
                              ></app-wallet-trend>
                            }

                            @if (eventSendOption === 'personas') {
                              <app-list-individual
                                id="main-view-list-individual"
                                [showAdminActions]="isUserAdmin"
                                (finishLoading)="hideDisplayProgressSpinner()"
                                (newDocumentShortcutClick)="openRegisterModal()"
                                (massiveLoadShortcutClick)="openFileUpload()"
                                (attributeEvolutionClick)="showAttributeEvolution($event)"
                                >
                              </app-list-individual>
                            }

                            @if (eventSendOption === 'orderTrackingProcessedFiles') {
                              <app-processed-tracking-records-files
                                id="main-view-processed-files"
                              ></app-processed-tracking-records-files>
                            }

                            @if (eventSendOption === 'attributeEvolution') {
                              <app-attribute-evolution
                                id="main-view-attr-evolution"
                                [planId]="attributeEvolutionData?.planId"
                                [documentNumber]="attributeEvolutionData?.documentNumber"
                                [registryId]="attributeEvolutionData?.registryId"
                                [inclusionDate]="attributeEvolutionData?.inclusionDate"
                                (backToList)="backToPersonasList()"
                              ></app-attribute-evolution>
                            }
                            @if (eventSendOption === 'preguntasFrecuentes') {
                              <app-frequent-question
                                id="main-view-faq"
                                (finishLoading)="hideDisplayProgressSpinner()"
                                >
                              </app-frequent-question>
                            }

                            @if (eventSendOption === 'walletDetails') {
                              <app-wallet-details
                                id="main-view-wallet-details"
                                (selectedOptionNavbar)="selectedOptionNavbar($event)"
                                [wallet]="selectedWallet"
                                >
                              </app-wallet-details>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-bottom: 0px" id="main-footer">
                  <div class="col-12" id="main-footer-logo-wrapper">
                    <img
                      src="{{ urlAssets }}/images/footer.png"
                      alt="Footer"
                      style="max-width: 30%; margin-left: 40px"
                      id="main-footer-img"
                      />
                    </div>
                    <div class="col-12" id="main-footer-text-wrapper">
                      <p
                        id="main-footer-copyright"
            style="
              text-align: left;
              line-height: 9px;
              font-size: 8px;
              margin-left: 50px;
              max-width: 500px;
            "
                        i18n="@@copyright"
                        >
            Copyright 2024 Equifax y las marcas relacionadas que aquí aparecen son marcas
            comerciales de Equifax, Inc.. Equifax y las marcas relacionadas que aquí aparecen son
            marcas comerciales de Equifax Argentina S.A.. Otros productos y nombres de Compañías
            aquí mencionados son propiedad de sus respectivos dueños.
          </p>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
